/**
* @typedef  PoissonDenominationConstructor
* @type {object}
* @property {number} idDenominationPoisson - the idDenominationPoisson value
* @property {string} nom - the nom value
* @property {number} idPoisson - the idPoisson value
* */

export class PoissonDenomination {
  /**
   * Creates an instance of PoissonDenomination.
   * @param {PoissonDenominationConstructor} object.idAchats
   * @memberof PoissonDenomination
   * */
  constructor(object) {
    this.idDenominationPoisson = object.idDenominationPoisson
    this.nom = object.nom
    this.raccourci = object.raccourci
    this.ponderation = object.ponderation
    this.idPoisson = object.idPoisson
  }

  getNameAttribute() {
    return 'nom'
  }

  getIdAttribute() {
    return 'idPoisson'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
